import React from "react";
import {Link} from "react-router-dom";

import "../../styles/layout/section-promo.scss";
import "../../styles/components/buttons/btn-white-o.scss";

import {HOW_CAN_I_HELP_CONTENT} from "../../constants/constants";

export default function ToHelp() {
  return (
    <section className="cf-section-promo">
      <div className="cf-section-promo__img">&nbsp;</div>
      <div className="cf-section-promo__body">
        <h3 className="cf-title">{HOW_CAN_I_HELP_CONTENT.title}</h3>
        <ul className="cf-section-promo__info">
          {HOW_CAN_I_HELP_CONTENT.list.map((item, index) => {
            return (
              <li key={index}>
                {/*Used to be Link, but changed it so it redirects to external website.*/}
                <a href={item.link}
                      target="_blank" rel="noopener noreferrer"
                      className='cf-subtitle'>
                  <span>{item.title}</span>
                </a>
                <p>{item.description}</p>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  );
}
